export interface LogTranslations {
    TABLE: {
        DATE: string;
        NAME: string;
        DETAILS: string;
        ACTIONS: string;
        CASO: string;
    };
    // Permitir más secciones de traducción
    [key: string]: any;
}

export const logTranslations: { [language: string]: LogTranslations } = {
    en: {
        TABLE: {
            DATE: "Date",
            NAME: "Name",
            DETAILS: "Details",
            ACTIONS: "Actions",
            CASO: "Case"
        },
    },
    es: {
        TABLE: {
            DATE: "Fecha",
            NAME: "Nombre",
            DETAILS: "Detalles",
            ACTIONS: "Acciones",
            CASO: "Caso"
        },
    },
};
